module.exports = __webpack_public_path__ + "img/advan-data_2x.7c3b0ba8.png";